﻿export interface IRecipientXm {
    donorCenterAlias: string,
    donorAlias: string,
    recipientAlias: string,
    requestedDate: string,
    xmStatusDeadline: string,
    xmTypeDescription: string,
    xmResultDescription: string
}
